import axios from 'axios';
import AuthService from '../services/authService';
import { getURL } from '../services/GeneralServices';

const axiosInstance = axios.create({
  baseURL: getURL(),
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const apiKey = AuthService.getApiKey();
    if (apiKey) {
      config.headers['x-api-key'] = apiKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
